(function () {
    'use strict';

    var startIndex;

    angular.module('SMART2').directive('smartSortable', [function () {
        return {
            restrict: 'A',
            scope: {
                onSort: '&'
            },
            link: function (scope, element, attrs) {
                element.sortable({
                    placeholder: attrs.placeholder ? attrs.placeholder : "drop-hover",
                    helper: attrs.helper ? attrs.helper : "original",
                    handle: ".collapsible-header-drag-icon",
                    items: ">*:not(.disable-sort-item)",
                    cancel: ".disable-sort-item",
                    connectWith: attrs.connectWith ? attrs.connectWith : "",
                    appendTo: attrs.appendTo ? attrs.appendTo : "parent",
                    start: function (event, ui) {
                        startIndex = ui.item.index();
                        if (ui.placeholder) {
                            ui.placeholder.height(ui.item.height()).css("width", ui.item.outerWidth());
                        }
                    },
                    update: function (event, ui) {
                        scope.$apply(function () {
                            scope.onSort({
                                $event: {
                                    startIndex: startIndex,
                                    endIndex: ui.item.index()
                                }
                            });
                        });
                        if (attrs.swipItem == "true") {
                            // swiping element position with each other
                            if (ui.sender) {
                                var el = ui.item.next().length == 1 ? ui.item.next() : ui.item.prev();
                                ui.sender.append(el);
                            }
                        }
                    },
                    sort: function (event, ui) {
                        //console.log({ event, ui })
                        if (attrs.whileSorting == "true") {
                            var ele = $(".slick-list"),
                                scrollpos = ele.scrollLeft(),
                                main_width = ele.outerWidth(),
                                ew = ui.helper.outerWidth(),
                                elft = ui.helper.offset().left - ele.offset().left,
                                rpos = (main_width - (elft + ew));
                            if (elft < 0) { // left
                                $('.slick-prev').click();
                            } else if (rpos < 0) { // right    
                                $('.slick-next').click();
                            }
                        }
                    }
                });
            }
        };
    }]);

    angular.module('SMART2').directive('isDraggable', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('isDraggable', function (isDraggable) {
                    if (isDraggable != undefined && isDraggable != "") {
                        if (isDraggable == 'true' || isDraggable == true) {
                            element.removeClass('disable-sort-item');
                        }
                        if (isDraggable == 'false' || isDraggable == false) {
                            element.addClass('disable-sort-item');
                        }
                    }
                });
            }
        };
    }]);



    //var droppableParent;

    ///*
    // * Highlight droppables on mouse down
    // */
    //var highlightDroppableElements = function (currentDraggableElement) {
    //    currentDraggableElement.removeAttr('style').addClass('being-dragged z-index-plus');
    //    angular.element('.ui-droppable').addClass('being-dropped-on');
    //};

    ///*
    // * Unhighlight droppables on mouse up
    // */
    //var unhighlightDroppableElements = function (currentDraggableElement) {
    //    currentDraggableElement.removeClass('being-dragged z-index-plus');
    //    angular.element('.ui-droppable').removeClass('being-dropped-on');
    //};

    ///*
    // *  This directive will handle dragging of portlet
    // */
    //angular.module('SMART2').directive('smartDraggable', [function () {
    //    return {
    //        restrict: 'A',
    //        link: function (scope, element, attrs) {
    //            if (attrs.smartDraggable == 'false' || attrs.smartDraggable == false) {
    //                return;
    //            }

    //            attrs.$observe('enabled', function (isEnabled) {
    //                if (isEnabled != undefined) {
    //                    if (isEnabled == 'true' || isEnabled == true) {
    //                        element.draggable('enable');
    //                    }
    //                    if (isEnabled == 'false' || isEnabled == false) {
    //                        element.draggable('disable');
    //                    }
    //                }
    //            });

    //            /*
    //             *  Make portlet dragging enabled
    //             */
    //            element.draggable({
    //                revert: 'invalid',
    //                handle: '.collapsible-header-drag-icon',
    //                revertDuration: 200,
    //                delay: 200,
    //                appendTo: 'body',
    //                containment: 'body',
    //                start: function () {
    //                    droppableParent = $(this).parent();
    //                    $(droppableParent).addClass('being-dragged z-index-plus');
    //                },
    //                drag: function (e) {
    //                    if (e.clientX > window.innerWidth - 10 || e.clientX < 10 || e.clientY > window.innerHeight - 10 || e.clientY < 10) {
    //                        $(document).trigger('mouseup');
    //                    }
    //                },
    //                stop: function () {
    //                    setTimeout(function () {
    //                        $(droppableParent).removeClass('being-dragged z-index-plus');
    //                        // clearTimeout(dragTimeout);
    //                    }, 250);
    //                }
    //            });
    //        }
    //    };
    //}]);


    ///*
    // *  This directive will handle dropping of portlet
    // */
    //angular.module('SMART2').directive('smartDroppable', ['$compile', '$timeout', function ($compile, $timeout) {
    //    return {
    //        restrict: 'A',
    //        link: function (scope, element, attrs) {
    //            if (attrs.smartDroppable == 'false' || attrs.smartDroppable == false) {
    //                return;
    //            }

    //            /*
    //             *  Make portlet dropping enabled
    //             */
    //            element.droppable({
    //                hoverClass: 'drop-hover',
    //                drop: function (event, ui) {
    //                    var draggable = $(ui.draggable[0]),
    //                        draggableOffset = draggable.offset(),
    //                        container = $(event.target),
    //                        containerOffset = container.offset();

    //                    $('.draggable', event.target).appendTo(droppableParent).css({ opacity: 0 }).animate({ opacity: 1 }, 200);
    //                    draggable.appendTo(container).css({ left: draggableOffset.left - containerOffset.left, top: draggableOffset.top - containerOffset.top }).animate({ left: 0, top: 0 }, 200);
    //                }
    //            });
    //        }
    //    };
    //}]);
})();
